module.exports = __webpack_public_path__ + "img/cash-wallet.23dd02a5.png";